module.exports = __webpack_public_path__ + "img/cargo_driving.548ce1a5.svg";